export const currency_locale_map = {
  IDR: "id-ID",
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
  JPY: "ja-JP",
  CNY: "zh-CN",
  KRW: "ko-KR",
  AUD: "en-AU",
  CAD: "en-CA",
  CHF: "de-CH",
  SGD: "en-SG",
  THB: "th-TH",
  MYR: "ms-MY",
  PHP: "en-PH",
  INR: "en-IN",
  AED: "ar-AE",
};

export function convert_to_currency_with_unit({ currency = "IDR", value }) {
  const currency_format = currency_locale_map[currency.toUpperCase()];
  return new Intl.NumberFormat(currency_format, {
    style: "currency",
    currency: currency,
    maximumFractionDigits: currency === "IDR" ? 0 : 2
  }).format(value);
}